
import { BrowserRouter } from 'react-router-dom';
import { useRoutes } from 'react-router-dom';
import routes from './router/config';
import { useAuth } from './hooks/useAuth';
import AuthModal from './components/auth/AuthModal';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import { useState } from 'react';

function AppRoutes() {
  const element = useRoutes(routes);
  return element;
}

function App() {
  const { user, loading } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="text-center">
          <img
            src="https://static.readdy.ai/image/976342a1a7f845a6b252d7e9ff105311/16e7a8fdc06168ca25b5a1e1505b0ed1.png"
            alt="Vibecode Logo"
            className="w-16 h-16 mx-auto mb-4 rounded-lg object-cover"
          />
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="text-gray-600 mt-4">Carregando...</p>
        </div>
      </div>
    );
  }

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <div className="App">
        <AppRoutes />
        <AuthModal 
          isOpen={showAuthModal} 
          onClose={() => setShowAuthModal(false)}
          initialMode="login"
        />
        <PWAInstallPrompt />
      </div>
    </BrowserRouter>
  );
}

export default App;
